
import { FormSection } from "@/models";
import { apiRequest, SUPABASE_URL } from "./apiUtils";
import { createApiWrapper } from "./apiWrapper";

export const formSectionApi = createApiWrapper<FormSection>('form-sections');

/**
 * Update the useful links for a form section
 * 
 * @param id The ID of the form section to update
 * @param links Array of useful links with label and URL
 * @returns The updated form section
 */
export const updateFormSectionLinks = async (
  id: number, 
  links: { label: string; url: string; }[]
): Promise<FormSection> => {
  return apiRequest<FormSection>(`${SUPABASE_URL}/form-sections/${id}`, {
    method: 'PATCH',
    body: { useful_links: links }
  });
};

/**
 * Update minimum quantity for a form section
 * 
 * @param id The ID of the form section to update
 * @param minQuantity Minimum quantity of elements required
 * @returns The updated form section
 */
export const updateFormSectionMinQuantity = async (
  id: number,
  minQuantity: number | null
): Promise<FormSection> => {
  return apiRequest<FormSection>(`${SUPABASE_URL}/form-sections/${id}`, {
    method: 'PATCH',
    body: { min_quantity: minQuantity }
  });
};
